import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { allCandidatesApi, type AllCandidatesParams } from '@/features/recruiter/api/allCandidates.api'

const ALL_CANDIDATES_KEY = ['recruiter', 'candidates', 'all'] as const

export function useAllCandidatesQuery(params: AllCandidatesParams) {
  return useQuery({
    queryKey: [...ALL_CANDIDATES_KEY, params],
    queryFn: () => allCandidatesApi.list(params),
    placeholderData: (previous) => previous,
  })
}

export function useAllCandidatesFilterOptions() {
  return useQuery({
    queryKey: [...ALL_CANDIDATES_KEY, 'filter-options'],
    queryFn: allCandidatesApi.filterOptions,
    staleTime: 10 * 60 * 1000,
  })
}

export function useToggleCandidateStar() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ studentProfileId, starred }: { studentProfileId: number; starred: boolean }) =>
      allCandidatesApi.setStarred(studentProfileId, starred),
    onSettled: () => queryClient.invalidateQueries({ queryKey: ALL_CANDIDATES_KEY }),
  })
}
